<template>
  <v-layout row wrap align-center v-on:keyup.enter="queryAllCourseInfo">
    <v-flex md2>
      <v-text-field
        :label="labels.course_code"
        v-model="course_no"
      ></v-text-field>
    </v-flex>
    <v-flex md2>
      <v-text-field
        :label="labels.course_title"
        v-model="course_name"
      ></v-text-field>
    </v-flex>
    <v-flex md2>
      <v-text-field
        :label="labels.teacher"
        v-model="course_teacher"
      ></v-text-field>
    </v-flex>
    <v-flex md2 align-self-center>
      <v-select
        v-model="select_course_notes"
        :items="course_notes"
        item-text="name"
        item-value="code"
        attach
        :label="labels.others"
        multiple
      ></v-select>
    </v-flex>
    <v-flex md2 align-self-center>
      <v-select
        v-model="select_Campus_notes"
        :items="course_Campus"
        item-text="name"
        item-value="code"
        attach
        :label="labels.Campus"
        multiple
      ></v-select>
    </v-flex>
    <v-flex md1 align-self-center>
      <v-checkbox :label="labels.excl_ntu" v-model="only_ntust"></v-checkbox>
    </v-flex>
    <v-flex md1 align-self-center>
      <v-checkbox
        :label="labels.graduate_program"
        v-model="only_master"
      ></v-checkbox>
    </v-flex>
    <v-flex md1 align-self-center>
      <v-checkbox
        :label="labels.under_graduate_program"
        v-model="only_under_graduate"
      ></v-checkbox>
    </v-flex>
    <v-flex md1>
      <v-btn
        round
        block
        :disabled="btn_state"
        v-on:click="queryAllCourseInfo()"
      >
        <v-icon>search</v-icon>
        {{ labels.search }}
        <a hidden>{{Listen_GetInfo}}</a>
      </v-btn>
    </v-flex>
  </v-layout>
</template>

<script>
import languages from "../../languages/TabAll.json";
import { debounce } from 'lodash';

export default {
  data: () => ({
    labels: {
      course_code: "",
      course_title: "",
      teacher: "",
      others: "",
      general_course: "",
      excl_ntu: "",
      graduate_program: "",
      under_graduate_program: "",
      search: "",
    },
    course_no: "",
    course_name: "",
    course_teacher: "",
    select_course_notes: [],
    select_Campus_notes: [],
    only_Intensive:false,
    only_general: "",
    only_ntust: "",
    only_master: "",
    only_under_graduate: "",
    course_notes: [],
    course_Campus: [],
    Get_Info:{
      Semester:"",
      CourseNo:"",
      CourseName:""
    },
  }),
  computed: {
    btn_state() {
      return this.$store.state.btn_state;
    },
    select_language() {
      return this.$store.state.select_language;
    },
    ///監聽Get傳入的參數
    Listen_GetInfo(){
      var getUrlString = location.href;
      var url = new URL(getUrlString);
      const info = {
          CourseNo: null,
          CourseName: null,
          Semester: null
        };
      if(url.searchParams.has("CourseNo") ||url.searchParams.has("CourseName"))
      {
          if(url.searchParams.has("CourseNo"))
          {
            var CourseNo=url.searchParams.get("CourseNo");
            info.CourseNo = CourseNo;
          }
          if(url.searchParams.has("CourseName"))
          {
            var CourseName=url.searchParams.get("CourseName");
            info.CourseName = CourseName;
          }
      }
      if(url.searchParams.has("Semester"))
      {
        var Semester=url.searchParams.get("Semester");
        info.Semester = Semester;
      } else
      {
        info.Semester = this.$store.state.select_semester;
      }
      return info;
    },
  },
  watch: {
    select_language(value) {
      this.setLanguage(value);
    },
    // ✅ 監聽 URL 變化（computed）
    Listen_GetInfo: {
      handler(newVal) {
        // 將 Listen_GetInfo 的值同步進 Get_Info
        if (newVal.CourseNo !== null) {
          this.course_no = newVal.CourseNo;
          this.Get_Info.CourseNo = newVal.CourseNo;
        }
        if (newVal.CourseName !== null) {
          this.course_name = newVal.CourseName;
          this.Get_Info.CourseName = newVal.CourseName;
        }
        if (newVal.Semester !== null) {
          this.Get_Info.Semester = newVal.Semester;
        }
      },
      immediate: true
    },
    ///GET帶有資料則執行查詢
    Get_Info: {
    handler: debounce(function() {
        if (this.Get_Info.Semester !== "" || this.Get_Info.CourseNo !== "" || this.Get_Info.CourseName !== "") {
          this.queryAllCourseInfo();
        }
      }, 
      300),
      deep: true
    },
  },
  created() {
      this.setLanguage(this.$store.state.select_language);

  },
  methods: {
    queryAllCourseInfo: function () {
      let find = false;
      let Intensive_find = false;
      for (var i = this.select_course_notes.length - 1; i >= 0; i--) {
        if (this.select_course_notes[i] === "general") {
          this.select_course_notes.splice(i, 1);
          find = true;
        }else if(this.select_course_notes[i] === "Intensive"){
          this.select_course_notes.splice(i, 1);
          Intensive_find = true;
          this.only_Intensive = true;
        }
      }

      if (find) {
        this.only_general = 1;
      } else {
        this.only_general = 0;
      }
      if (
        this.course_no == "" &&
        this.course_name == "" &&
        this.course_teacher == "" &&
        this.select_course_notes == "" &&
        this.select_Campus_notes == "" &&
        this.only_Intensive != true &&
        this.only_general != true &&
        this.only_ntust != true &&
        this.only_master != true &&
        this.only_under_graduate != true
      ) {
        this.$store.commit("showAlert", "請輸入查詢條件!");
      } else {
        let Get_Semester = this.Get_Info.Semester != "" ? this.Get_Info.Semester : this.$store.state.select_semester;
        var query_params = {
          Semester: Get_Semester,
          CourseNo: this.course_no,
          CourseName: this.course_name,
          CourseTeacher: this.course_teacher,
          Dimension: "",
          CourseNotes: this.select_course_notes,
          CampusNotes: this.select_Campus_notes,
          ForeignLanguage: 0,
          OnlyIntensive: this.only_Intensive * 1,
          OnlyGeneral: this.only_general * 1,
          OnleyNTUST: this.only_ntust * 1,
          OnlyMaster: this.only_master * 1,
          OnlyUnderGraduate: this.only_under_graduate * 1,
          OnlyNode: this.$store.state.only_node * 1,
          Language: this.select_language.lang,
        };
        this.$store.dispatch("queryCourseInfo", query_params);
        if (find) {
          this.select_course_notes.push("general");
        }
        if (Intensive_find) {
          this.select_course_notes.push("Intensive");
          this.only_Intensive = false;
        }
      }
    },
    setLanguage: function (select_language) {
      this.labels.course_code = languages.course_code[select_language.lang];
      this.labels.course_title = languages.course_title[select_language.lang];
      this.labels.teacher = languages.teacher[select_language.lang];
      this.labels.others = languages.others[select_language.lang];
      this.labels.Campus = languages.Campus[select_language.lang];
      this.labels.general_course =
        languages.general_course[select_language.lang];
      this.labels.excl_ntu = languages.excl_ntu[select_language.lang];
      this.labels.graduate_program =
        languages.graduate_program[select_language.lang];
      this.labels.under_graduate_program =
        languages.under_graduate_program[select_language.lang];
      this.labels.search = languages.search[select_language.lang];
      this.course_notes = [
        { name: languages.eng_program[select_language.lang], code: "eng" },
        { name: languages.mentor[select_language.lang], code: "cot" },
        { name: languages.PBL[select_language.lang], code: "PBL" },
        { name: languages.Distance[select_language.lang], code: "DLC" },
        { name: languages.Innovative[select_language.lang], code: "ITC" },
        { name: languages.EMI[select_language.lang], code: "EMI" },
        { name: languages.Intensive[select_language.lang], code: "Intensive" },
        { name: languages.general_course[select_language.lang], code: "general", }
      ];
      this.course_Campus = [
        { name: languages.Main_Campus[select_language.lang], code: "Main_Campus" },
        { name: languages.Hwa_Hsia_Campus[select_language.lang], code: "Hwa_Hsia_Campus" },
        { name: languages.Hsinchu_Campus[select_language.lang], code: "Hsinchu_Campus" },
      ];
    },
  },
};
</script>
